import React from'react';import{Handle,Position}from'@xyflow/react';import{Card}from'antd';/**
 * Extended node data interface for base node functionality
 */import{jsx as _jsx,Fragment as _Fragment,jsxs as _jsxs}from"react/jsx-runtime";/**
 * Base class for all tutor flow nodes
 * Handles common functionality:
 * - Initial positioning and visibility
 * - Loading states
 * - Error handling
 * - Common handles
 * - Fade-in animations
 */export class BaseNode extends React.Component{constructor(){super(...arguments);this.nodeRef=/*#__PURE__*/React.createRef();}// Cast data to our type
get data(){return this.props.data;}// Default dimensions
get nodeWidth(){var _this$data;return((_this$data=this.data)===null||_this$data===void 0?void 0:_this$data.nodeWidth)||360;}get nodeHeight(){var _this$data2;return((_this$data2=this.data)===null||_this$data2===void 0?void 0:_this$data2.nodeHeight)||320;}// Common style for all nodes during initialization
get baseStyle(){return{width:this.nodeWidth,height:this.nodeHeight,transition:'opacity 0.3s ease-in-out'};}// Common class names
get baseClassName(){var _this$data3,_this$data4,_this$data5;const classes=['tutor-node'];if((_this$data3=this.data)!==null&&_this$data3!==void 0&&_this$data3.loading)classes.push('loading');if((_this$data4=this.data)!==null&&_this$data4!==void 0&&_this$data4.dimmed)classes.push('dimmed');if((_this$data5=this.data)!==null&&_this$data5!==void 0&&_this$data5.error)classes.push('error');return classes.join(' ');}// Render common handles
renderHandles(){return/*#__PURE__*/_jsxs(_Fragment,{children:[/*#__PURE__*/_jsx(Handle,{type:"target",position:Position.Top,id:"top-target"}),/*#__PURE__*/_jsx(Handle,{type:"source",position:Position.Top,id:"top-source"}),/*#__PURE__*/_jsx(Handle,{type:"source",position:Position.Bottom,id:"bottom-source"}),/*#__PURE__*/_jsx(Handle,{type:"target",position:Position.Left,id:"left-target"}),/*#__PURE__*/_jsx(Handle,{type:"source",position:Position.Right,id:"right-source"})]});}// Render loading state
renderLoading(){return/*#__PURE__*/_jsx("div",{className:"loading-container",children:/*#__PURE__*/_jsx("div",{className:"loading-spinner"})});}// Render error state
renderError(){var _this$data6;if(!((_this$data6=this.data)!==null&&_this$data6!==void 0&&_this$data6.error))return null;return/*#__PURE__*/_jsx("div",{className:"error-container",children:/*#__PURE__*/_jsx("p",{className:"error-message",children:this.data.error})});}// Abstract method - subclasses must implement their content
// Optional card wrapper - can be overridden
renderCard(content){return/*#__PURE__*/_jsx(Card,{className:"node-card",style:{width:'100%',height:'100%'},styles:{body:{height:'100%',padding:0,overflow:'auto'}},children:content});}render(){var _this$data7,_this$data8;return/*#__PURE__*/_jsxs("div",{ref:this.nodeRef,className:this.baseClassName,style:this.baseStyle,children:[this.renderHandles(),(_this$data7=this.data)!==null&&_this$data7!==void 0&&_this$data7.loading?this.renderLoading():(_this$data8=this.data)!==null&&_this$data8!==void 0&&_this$data8.error?this.renderError():this.renderCard(this.renderContent())]});}}/**
 * Factory function to create a node with base initialization logic
 * Ensures proper initial positioning and styling
 */export function createNodeWithBaseInit(id,type,parentPosition,data,additionalStyle){// Start at parent position to avoid origin flash, or (0,0) for root nodes
const position=parentPosition?{...parentPosition}:{x:0,y:0};return{id,type,position,style:{opacity:0,pointerEvents:'none',...additionalStyle},data:{...data,nodeId:id}};}/**
 * Factory function to create an edge with base initialization
 */export function createEdgeWithBaseInit(id,source,target,sourceHandle,targetHandle,additionalStyle){return{id,source,target,sourceHandle,targetHandle,type:'smoothstep',animated:true,style:{stroke:'#1a90ff',opacity:0,...additionalStyle},markerEnd:{type:'arrowclosed',color:'#1a90ff',width:20,height:20}};}/**
 * Base styles for node components
 */export const baseNodeStyles=`
  .tutor-node {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }

  .tutor-node.loading {
    opacity: 0.7;
  }

  .tutor-node.dimmed {
    opacity: 0.5;
  }

  .tutor-node.error {
    border: 2px solid #ff4d4f;
  }

  .loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
  }

  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #1890ff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .error-container {
    padding: 16px;
    text-align: center;
  }

  .error-message {
    color: #ff4d4f;
    margin: 0;
  }
`;